import {ENDPOINTS} from 'constants/endpoints';
import {apiConfig} from 'libs/api/api';

type DyEventType = {
    name: string;
    properties?: {[key: string]: unknown};
};

/**
 * Send event to dy via server
 * @param {DyEventType} events - list of custom events
 */
export const sendDyEventAnalytics = async (events: DyEventType) => {
    try {
        await apiConfig.instanceGusaBackend.request({
            baseURL: '/',
            data: {
                events,
            },
            method: 'POST',
            url: ENDPOINTS.FETCH_DY_ANALYTICS,
        });
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`ERROR IN DY EVENT: ${error.message}`);
    }
};
